import { graphql } from '@/gql';

export const GET_BENACHRICHTIGUNGEN = graphql(`
  query GetBenachrichtigungen($standortId: String!) {
    navigation_benachrichtigungen2(standortId: $standortId) {
      fehlendeArbeitszeit {
        id
        status
        datum
        mitarbeiter {
          vorname
          nachname
          bildUrl
          id
        }
        arbeitsbereich {
          id
          name
          markierung
        }
      }
      abwesenheitsantraege {
        bis
        von
        grund
        id
        markierung
        mitarbeiter {
          bildUrl
          id
          nachname
          vorname
        }
      }
      fristen {
        id
        ablaufZeitpunkt
        grund
        gelesen
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
        }
      }
      krankmeldungen {
        istKindkrank
        mitarbeiter {
          id
          bildUrl
          vorname
          nachname
          istExtern
        }
        voraussichtlichVon
        voraussichtlichBis
      }
      dokumente {
        erstellungsDatum
        id
        mitarbeiter {
          id
          bildUrl
          vorname
          nachname
        }
        name
      }
      mitarbeiterantraege {
        id
        erstellungsDatum
        mitarbeiter {
          bildUrl
          id
          nachname
          vorname
        }
      }

      schichttauschantraege {
        id
        schicht {
          arbeitsbereich {
            id
            markierung
            name
          }
          beginn
          ende
        }
        mitarbeiter {
          id
          bildUrl
          vorname
          nachname
        }
      }
    }
  }
`);
